// extracted by mini-css-extract-plugin
export default {"advs":"advs___df9e71d58a72e1b1b697","advsTitle":"advsTitle___e5fc4f379e94584e71cc","titleBig":"titleBig___e66393a6cb9fb7c5ce4f"};